export const getStrategySamplePortfolio = `
query getStrategySamplePortfolio($strategyId: String) {
  getStrategySamplePortfolio(input: {strategyId: $strategyId}) {
    id
    name
    cash
    distributions{
      assetClass
      distribution {
        name
        y: percentage
      }
    }
    shareEntries {
      items {
        id
        assetClass
        count
        averagePrice
        instrument {
          assetClass
          id
          finScore
          name
          isin
          active
          delisted
          covered
          close
          latestPrice {
            price
          }
        }
      }
    }
  }
}
`


export const getStrategySamplePortfolioTimeSeriesRTLastValues = /* GraphQL */ `
query getPortfolioTimeSeriesRTLastValues($portfolioId: ID!, $assetClass: String!) {
  getPortfolioRatioDataRealTime(portfolioId: $portfolioId, assetClass: $assetClass) {
        currentValue
        yield
        yield1D
        yield1Y
        growthAmount
        timestamp
  }
}
`
